import moment from 'moment'
import _ from 'lodash'

import { Api, Config } from './api'

export const ApiObterRelatorios = async (filtros) => {
   const formatData = 'YYYY-MM-DD'
   const params = new URLSearchParams()

   if (filtros && filtros.ordenar) {
      params.append('ordenar', filtros.ordenar)
   }

   if (filtros && filtros.tipoRelatorio) {
      params.append('tipo', filtros.tipoRelatorio)
   }

   if (filtros && filtros.dataCriacao) {
      let dataFiltro

      if (filtros && filtros.dataCriacao.length > 1 && filtros.dataCriacao[1] !== null) {
         dataFiltro = `${moment(filtros.dataCriacao[0]).format(formatData)},${moment(filtros.dataCriacao[1]).format(formatData)}`
      } else {
         dataFiltro = moment(filtros.dataCriacao[0]).format(formatData)
      }

      params.append('dataCriacao', dataFiltro)
   }

   if (filtros && filtros.status) {
      params.append('status', filtros.status)
   }

   if (filtros && filtros.pagina) {
      params.append('pagina', filtros.pagina)
   }

   if (filtros && filtros.limite) {
      params.append('limite', filtros.limite)
   }

   const { data } = await Api.get(`/relatorios`, Config(params))

   return data
}

export const ApiReprocessarRelatorio = async (idTarefa) => {
   const { data } = await Api.post(`/relatorios/${idTarefa}/reprocessar`, {}, Config())
   return data
}

export const ApiGerarRelatorio = async (payload) => {
   const formatData = 'YYYY-MM-DD'

   const payloadRedefined = {}

   if (payload.ativo) {
      payloadRedefined.ativo = payload.ativo
   }
   if (payload.codigoCargo) {
      payloadRedefined.codigoCargo = payload.codigoCargo
   }
   if (payload.codigoSede) {
      payloadRedefined.codigoSede = payload.codigoSede
   }
   if (payload.codigoUnidadeLotacao) {
      payloadRedefined.codigoUnidadeLotacao = payload.codigoUnidadeLotacao
   }
   if (payload.cpf) {
      payloadRedefined.cpf = payload.cpf
   }
   if (payload.dataAdmissao) {
      let dataFiltro

      if (payload.dataAdmissao.length > 1) {
         dataFiltro = `${moment(payload.dataAdmissao[0]).format(formatData)},${moment(payload.dataAdmissao[1]).format(formatData)}`
      } else {
         dataFiltro = moment(payload.dataAdmissao).format(formatData)
      }

      payloadRedefined.dataAdmissao = dataFiltro
      payloadRedefined.dataAdmissao = dataFiltro
   }
   if (payload.dataCriacaoFim) {
      payloadRedefined.dataCriacaoFim = payload.dataCriacaoFim
   }
   if (payload.dataCriacaoInicio) {
      payloadRedefined.dataCriacaoInicio = payload.dataCriacaoInicio
   }
   if (payload.dataInicio) {
      let dataFiltro

      if (payload.dataInicio.length > 1) {
         dataFiltro = `${moment(payload.dataInicio[0]).format(formatData)},${moment(payload.dataInicio[1]).format(formatData)}`
      } else {
         dataFiltro = moment(payload.dataInicio).format(formatData)
      }
      payloadRedefined.dataInicio = dataFiltro
      payloadRedefined.dataInicio = dataFiltro
   }
   if (payload.dataUltimaAlteracaoFim) {
      payloadRedefined.dataUltimaAlteracaoFim = payload.dataUltimaAlteracaoFim
   }
   if (payload.dataUltimaAlteracaoInicio) {
      payloadRedefined.dataUltimaAlteracaoInicio = payload.dataUltimaAlteracaoInicio
   }
   if (payload.email) {
      payloadRedefined.email = payload.email
   }
   if (payload.grupomrs) {
      payloadRedefined.grupomrs = payload.grupomrs
   }
   if (payload.limite) {
      payloadRedefined.limite = payload.limite
   }
   if (payload.localTrabalho) {
      payloadRedefined.localTrabalho = payload.localTrabalho
   }
   if (payload.matricula) {
      payloadRedefined.matricula = payload.matricula
   }
   if (payload.matriculaGestor) {
      payloadRedefined.matriculaGesto = payload.matriculaGesto
   }
   if (payload.nome) {
      payloadRedefined.nome = payload.nome
   }
   if (payload.ordenar) {
      payloadRedefined.ordenar = payload.ordenar
   }
   if (payload.pagina) {
      payloadRedefined.pagina = payload.pagina
   }
   if (payload.pis) {
      payloadRedefined.pis = payload.pis
   }

   if (payload.grupoSelecionado) {
      let userInfo = GetLocalUserInfo()
      let grupo = _.find(userInfo.grupos, { id: `${payload.grupoSelecionado}` })
      if (grupo) {
         payloadRedefined.gestorId = grupo.gestorId
         payloadRedefined.tipoVisibilidade = grupo.tipoVisibilidade
      }
   }

   const { data } = await Api.post(`/relatorios/historico-funcionarios`, payloadRedefined, Config())

   return data
}
export const ApiGerarRelatorioUsuDelegacao = async (filtros) => {
   const formatData = 'YYYY-MM-DD'

   const payload = {}

   if (filtros.pagina) {
      payload.pagina = filtros.pagina
   }

   if (filtros.limite) {
      payload.limite = filtros.limite
   }
   if (filtros.delegadorNome) {
      payload.delegadorNome = filtros.delegadorNome
   }
   if (filtros.delegadoNome) {
      payload.delegadoNome = filtros.delegadoNome
   }
   if (filtros.perfilSap) {
      payload.perfilSap = filtros.perfilSap
   }
   if (filtros.dataInicio) {
      let dataFiltro

      if (filtros.dataInicio.length > 1) {
         dataFiltro = `${moment(filtros.dataInicio[0]).format(formatData)},${moment(filtros.dataInicio[1]).format(formatData)}`
      } else {
         dataFiltro = moment(filtros.dataInicio).format(formatData)
      }
      payload.dataInicio = dataFiltro
   }
   if (filtros.dataFim) {
      let dataFiltro

      if (filtros.dataFim.length > 1) {
         dataFiltro = `${moment(filtros.dataFim[0]).format(formatData)},${moment(filtros.dataFim[1]).format(formatData)}`
      } else {
         dataFiltro = moment(filtros.dataFim).format(formatData)
      }

      payload.dataFim = dataFiltro
   }

   const { data } = await Api.post(`/relatorios/historico-delegacoes-equipe`, payload, Config())

   return data
}
